import React, { useEffect } from "react"

import './index.css'

const TemplateSmallHero = ({ style, details, children, thumbnailImage, thumbnailPosition }) => {
    const backgroundStyle = {
        backgroundImage: `url(${thumbnailImage})`,
        backgroundSize: "cover",
        backgroundPosition: thumbnailPosition === 'Default' ? 'center' : thumbnailPosition
    };
    return (
        <div className={style}>
            {details}
            <div className="small-hero-wrap" style={backgroundStyle}>
                {children}
            </div>
        </div>
    )
}

const TemplateSlantedHero = ({ style, details, children, backgroundStyle, isVideo=false }) => {
    return (
        <div style={backgroundStyle} className={`${style} ${isVideo && 'video-handler'}`}>
            {children}
            {details}
        </div>
    )
}

const BlogHeroMedia = ({ data, children, className='', template="", link}) => {
    const isMP4Format = (url) => {
        const mp4Regex = /\.(mp4)$/i;
        return mp4Regex.test(url);
    };
    
    const isYouTubeVideo = (url) => {
        const youtubeRegex = /(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/|v\/|u\/\w\/|shorts\/)?([^?&]+)/;
        return youtubeRegex.test(url);
    };

    const imageExtensions = /\.(jpg|jpeg|png|svg)$/i;
    
    const isVimeoVideo = (url) => {   
        const vimeoRegex = /(?:vimeo\.com\/video|player\.vimeo\.com\/video)\/(\d+)/;   
        return vimeoRegex.test(url); 
    };
    
    const url = data.heroMediaLink
    const videoId = isYouTubeVideo(url) ? url.match(/(?:\/|%2F)([A-Za-z0-9_-]{11})/)[1] : '';

    useEffect(() => {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      
        let player;
      
        window.onYouTubeIframeAPIReady = () => {
          player = new window.YT.Player('mainVideo', {
            videoId: videoId,
            playerVars: {
                autoplay: 1,
                controls: template !== "Hero with Small Feature Image" ? 0 : 1,
                showinfo: 0,
                mute: 1,
                modestbranding: 1,
                wmode:'transparent'
            },
          });
      
          player.addEventListener('onStateChange', (event) => {
            if (event.data === window.YT.PlayerState.ENDED) {
              player.seekTo(0);
            }
          });
        };
    }, [videoId]);

    if (isYouTubeVideo(url)) {

        return (
            <>
                {template !== "Hero with Small Feature Image" ? (
                    <TemplateSlantedHero style={className} details={children} isVideo={true}>
                        {videoId !== null && (
                            <div id="mainVideo"></div>
                        )}
                    </TemplateSlantedHero>
                ): template !== "Hero with Small Feature Image" 
                ? (
                    <div className="global-hero">{videoId !== null && (
                        <div id="mainVideo"></div>
                    )}</div>
                ): (
                    <TemplateSmallHero style={className} details={children} thumbnailImage={data.thumbnailImage.gatsbyImageData.images.fallback.src} thumbnailPosition={data.thumbnailPosition}>
                        {videoId !== null && (
                            <div id="mainVideo"></div>
                        )}
                    </TemplateSmallHero>
                )}
                
            </>
        )
    } else if (isMP4Format(url)) {
        return (
            <>
                {template !== "Hero with Small Feature Image" ? (
                    <TemplateSlantedHero style={className} details={children} isVideo={true}>
                        <video autoPlay loop muted>
                            <source src={url} type="video/mp4" />
                            <track src="captions_en.vtt" kind="captions" srcLang="en" label="English Captions"></track>
                        </video>
                    </TemplateSlantedHero>
                ):(
                    <TemplateSmallHero style={className} details={children}>
                        <video autoPlay loop muted>
                            <source src={url} type="video/mp4" />
                            <track src="captions_en.vtt" kind="captions" srcLang="en" label="English Captions"></track>
                        </video>
                    </TemplateSmallHero>
                )}
            </>
        )
    } else if (imageExtensions.test(url)) {
        const backgroundStyle = {
            backgroundImage: `url(${url})`,
            backgroundSize: "cover",
            // backgroundPosition: "center center",
        };
        return (
            <>
            {template !== "Hero with Small Feature Image" ? (
                <TemplateSlantedHero style={className} details={children} backgroundStyle={backgroundStyle}>

                </TemplateSlantedHero>
            ):(
                <TemplateSmallHero style={className} details={children}>          
                    <img src={url} alt={data.postTitle || 'Small Hero Background'} />
                </TemplateSmallHero>
            )}
            </>
        )
    } else if (isVimeoVideo(url)) {
        return (
            <>
                {template !== "Hero with Small Feature Image" ? (
                    <TemplateSlantedHero style={className} details={children} isVideo={true}>
                        <iframe 
                        width="424" 
                        height="238" 
                        src={`${url}?autoplay=${1}&muted=1&loop=1&controls=0`} 
                        title="We Are Savor Brands" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowFullScreen></iframe>
                    </TemplateSlantedHero>
                ):(
                    <TemplateSmallHero style={className} details={children}>
                        <iframe 
                        width="424" 
                        height="238" 
                        src={`${url}?autoplay=${1}&muted=1&loop=1&controls=0`}
                        title="We Are Savor Brands" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowFullScreen></iframe>
                    </TemplateSmallHero>
                )}
            </>
        )
    } else {
        return (
            <>Invalid Format</>
        )
    } 
    
}

export default BlogHeroMedia